/**
 * FlowAvatarOrb — React-Wrapper um flow-avatar.js (#1393, Voice V1b-Polish).
 *
 * flow-avatar.js bleibt verbatim (AK3) — der Wrapper instanziiert die Klasse
 * imperativ, mappt React-Props auf setState()/setAmplitude() und ruft
 * destroy() beim Unmount (kein RAF-Leak). 'connecting' ist als zusätzlicher
 * statusTexts-Key erlaubt (setState akzeptiert jeden Key aus statusTexts);
 * visuell bleibt das Symbol dabei statisch.
 */
import { useEffect, useRef } from 'react';
// UMD-Datei (verbatim, AK3): registriert sich im Browser als window.FlowAvatar
import './flow-avatar';

const FlowAvatar = typeof window !== 'undefined' ? window.FlowAvatar : null;

export default function FlowAvatarOrb({ state, amplitude, size = 140, statusTexts }) {
  const hostRef = useRef(null);
  const avatarRef = useRef(null);
  const stateRef = useRef(state);
  stateRef.current = state;

  // Sprachwechsel (neue statusTexts) → Instanz neu aufbauen
  const textsKey = JSON.stringify(statusTexts);

  useEffect(() => {
    const avatar = new FlowAvatar(hostRef.current, { size, showStatus: true, statusTexts });
    avatarRef.current = avatar;
    avatar.setState(stateRef.current);
    return () => {
      avatar.destroy();
      avatarRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size, textsKey]);

  useEffect(() => {
    avatarRef.current?.setState(state);
  }, [state]);

  useEffect(() => {
    avatarRef.current?.setAmplitude(amplitude);
  }, [amplitude]);

  return <div ref={hostRef} className="w-full" />;
}
